// import service from '@/api'
import Vue from 'vue'
import { asyncMap } from '../router'
// this is a dangerous code by zq
function hack(v, a = []) {
    v.forEach(k => { if (k.name) { a.push(k.name) } if (k.children && k.children.length) { return hack(k.children, a) } })
    return a
}
const actions = {
    setMenuList: ({ commit }, payload) => {
        if (payload) {
            commit('SET_MENULIST', hack(asyncMap))
        } else {
            return Vue.prototype.$http('GET', '/roleMenu/menuCode').then(res => {
                if (res.data.code === 200) {
                    sessionStorage.setItem('nameList', res.data.content)
                    commit('SET_MENULIST', res.data.content)
                }
            })
        }
    }
}
export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js